import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Odometer = dynamic(() => import('react-odometerjs'), { ssr: false });

import { ImageComponent } from '@/components/Image';
import { COVERFLOW_SLIDER_PAYMENTS } from '../../helpers';

import { ScJackpotCard } from './styled';

import 'odometer/themes/odometer-theme-default.css';
import dynamic from 'next/dynamic';

interface IJackpotCardProps {
  translation: string;
  bgImage: string;
}

export const JackpotCard = ({ translation, bgImage }: IJackpotCardProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(translation);

  const [jackpot, setJackpot] = useState(109_999.01);

  useEffect(() => {
    const interval = setInterval(() => {
      setJackpot((prev) => {
        const increment = +(Math.random() * (10.0 - 0.2) + 0.2).toFixed(2);
        let next = +(prev + increment).toFixed(2);

        if (next % 1 === 0) {
          next += 0.02;
        }

        const decimals = next.toFixed(2).split('.')[1];
        if (decimals[1] === '0') {
          next = +(next.toFixed(2).slice(0, -1) + '1');
        }

        return next;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  return (
    <ScJackpotCard bgImage={bgImage}>
      <ImageComponent
        alt="seven"
        className="decor left-top"
        height={96}
        src="/lp/dragon-pearls-november-25/7.webp"
        width={101}
      />
      <ImageComponent
        alt="coinTop"
        className="decor right-top"
        height={66}
        src="/lp/dragon-pearls-november-25/coins-gold-top.webp"
        width={66}
      />
      <ImageComponent
        alt="star"
        className="decor right-bottom"
        height={132}
        src="/lp/dragon-pearls-november-25/star.webp"
        width={141}
      />
      <ImageComponent
        alt="coin"
        className="decor left-bottom"
        height={66}
        src="/lp/dragon-pearls-november-25/coins-gold.webp"
        width={66}
      />

      <div className="content">
        <div className={`jackpot ${language}`}>
          <p className="title">{t('jackpotCard.title')}</p>
          <div className="amount">
            <span>{t('jackpotCard.currency')}</span>
            <Odometer duration={1500} format="(,ddd).dd" value={jackpot} />
          </div>
        </div>

        <div className="payments">
          {COVERFLOW_SLIDER_PAYMENTS.map((item, index) => (
            <ImageComponent
              alt={item.alt}
              height={item.height}
              key={index}
              src={item.src}
              width={item.width}
            />
          ))}
        </div>
      </div>
    </ScJackpotCard>
  );
};
